<template>
<m-pageframe
    :title="page_title"
>

<v-container v-if="inbox != null">

   <m-edit-text
        label="Label (internal use only)"
        v-model="inbox.internal_label"
        :read_only="read_only"
        v-on:input="postInbox"
    />

    <m-edit-text
        label="Help With (visible on your website)"
        v-model="inbox.help_with"
        :read_only="read_only"
        v-on:input="postInbox"
    />

    <m-edit-text
        label="Inbox UUID"
        :value="inbox.inbox_id"
        read_only
    />

    <m-edit-text
        label="Inbox Email Address"
        :value="inbox.inbox_id + '@redchirp-mail.com'"
        :menu_items="[{'text' : 'Inbox email log...', 'event' : 'email-log'}]"
        v-on:email-log="onClickInboxEmailLog"
    />

    <m-restricted-field
        v-if="$rc.$state.isAuthActorSystemAdmin()"
        position="top-right"
    >
        <m-edit-text
            label="Forward To"
            :value="forward_to"
            :read_only="false"
            :custom_on_edit="onClickEditForwardTo"
        />
    </m-restricted-field>
    <m-edit-text
        v-else
        label="Forward To"
        :value="forward_to"
        read_only
    />

    <v-divider
        style="margin-top: 15px; margin-bottom: 15px;"
    />

    <div
        v-if="has_forward_to"
        style="margin-bottom: 15px;"
    >
        <h2
            style="margin-bottom: 10px;"
        >
            Notification Plan
        </h2>

        Because this inbox is set to forward all requests, the notificatin plan has no effect.

        <h2
            style="margin-bottom: 10px; margin-top: 15px;"
        >
            Active Hours
        </h2>

        Because this inbox is set to forward all requests, the active hours have no effect.  This inbox will forward contact requests 24/7.

        <h2
            style="margin-bottom: 10px; margin-top: 15px;"
        >
            Auto Responses
        </h2>

        Because this inbox is set to forward all requests, any auto responses have no effect.
    </div>

    <div
        v-show="!has_forward_to"
    >

    <h2
        style="margin-bottom: 15px;"
    >
        Notification Plan
    </h2>

    <v-alert
        v-if="inbox.plan.stages.length === 0"
        type="info"
        color="primary"
        border="left"
        elevation="0"
        class="shaded-light mb-4"
        colored-border
        dense
    >
        <div class="text-h6">No Notification Plan Set Up</div>
        <p class="mb-0">It is recommended to set up at least one notification stage to ensure your team receives contact requests. Click the + button below to create your first stage.</p>
    </v-alert>

    <v-card
        v-for="(stage, index) in inbox.plan.stages"
        :key="index"
        style="margin-bottom: 15px"
    >
        <v-card-title>Stage {{index+1}}</v-card-title>

        <v-card-text>

        <m-edit-chip
            label="Who can be notified"
            :dialog_title="'Who can be notified in stage ' + (index+1)"
            :value="createStageChips(stage)"
            :possible_values="createPossibleChips()"
            :read_only="read_only"
            v-on:input="setStageValue($event,index)"
        />

        <m-edit-select
            label="How to pick who to notify"
            :value="getNotificationType(stage.step.action.type)"
            :possible_values="notification_options"
            :read_only="read_only"
            v-on:input="setNotificationType($event,index)"
        />

        <m-edit-text
            label="How long to wait after sending a notification (in minutes)"
            :value="''+describeWaitTime(stage.step.wait_time)"
            v-on:input="setWaitTime($event,index)"
            :read_only="read_only"
            integer_positive_non_zero
        />

        <m-edit-text
            label="How many times to repeat this process before advancing to the next stage"
            :value="''+stage.repeat_count"
            :read_only="read_only"
            integer_positive_non_zero
            v-on:input="setRepeatCount($event,index)"
        />

        </v-card-text>

        <div
            style="position: absolute; right: 20px; top: 20px;"
        >
            <v-menu
                bottom
                offset-y
            >

                    <template v-slot:activator="{ on }">

                        <v-icon
                            v-on="on"
                            color="primary"
                        >
                            mdi-dots-vertical
                        </v-icon>

                    </template>

                    <v-list>
                        <v-list-item
                            :disabled="index == 0"
                            v-on:click="moveStage(index,true)"
                        >
                            <v-list-item-title>Move Up</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            :disabled="index == inbox.plan.stages.length-1"
                            v-on:click="moveStage(index,false)"
                        >
                            <v-list-item-title>Move Down</v-list-item-title>
                        </v-list-item>


                        <v-divider/>

                        <v-list-item
                            v-on:click="newStage(index, true)"
                        >
                            <v-list-item-title>New stage before</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="newStage(index, false)"
                        >
                            <v-list-item-title>New stage after</v-list-item-title>
                        </v-list-item>

                        <v-divider/>

                        <v-list-item
                            v-on:click="deleteStage(index)"
                        >
                            <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>

                        <v-divider/>

                         <v-list-item
                            v-on:click="onClickCopyFromAnotherInbox()"
                        >
                            <v-list-item-title>Copy settings to/from another inbox...</v-list-item-title>
                        </v-list-item>

                    </v-list>

                </v-menu>


        </div>

    </v-card>

    <v-row>
        <v-col>
        </v-col>

        <v-col
            class='flex-grow-0'
        >
            <v-btn
                class="mx-2" fab dark small color="primary"
                v-on:click="addStage()"
            >
                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
        </v-col>
    </v-row>

    <v-divider
        style="margin-top: 15px; margin-bottom: 15px;"
    />

    <v-row>
        <v-col
            style="margin-bottom: 15px;"
        >
            <h2
                style="margin-bottom: 10px;"
            >
                Active Hours
            </h2>
            <v-subheader>
                Active Hours are the times your team is typically available to respond. Once you define your active hours, customize Auto Replies (below) and the RedChirp bot will automatically text helpful confirmations.
                This helps keep leads warm and informed when it's taking longer than usual to respond during your active hours, or requests come in during inactive hours.
            </v-subheader>
        </v-col>

        <v-col
            class='flex-grow-0'
        >
            <v-menu
                bottom
                offset-y
            >

            <template v-slot:activator="{ on }">

                <v-icon
                    v-on="on"
                    style="margin-top: 20px;"
                >
                    mdi-dots-vertical
                </v-icon>

            </template>

            <v-list>
                <v-list-item
                    v-on:click="onClickCopyFromAnotherInbox()"
                >
                    <v-list-item-title>Copy settings to/from another inbox...</v-list-item-title>
                </v-list-item>

            </v-list>

            </v-menu>


        </v-col>
    </v-row>

    <m-daily-schedule
        v-model="inbox.active_hours"
        :read_only="false"
        v-on:input="postInbox"
    />

    <v-divider
        style="margin-top: 15px; margin-bottom: 15px;"
    />

    <h2
        style="margin-bottom: 15px;"
    >
        Auto Responses
    </h2>

    <v-card
        v-for="(auto_response, index) in inbox.auto_responses"
        :key="'auto_response_' + index"
        style="margin-bottom: 15px"
    >
        <v-card-text>
            <v-switch
                label="Enabled"
                v-model="auto_response.enabled"
                v-on:change="postInbox"
            />

            <v-select
                label="During What Time?"
                :items="during_intervals"
                v-model="auto_response.during"
                v-on:input="postInbox"
            />

            <m-edit-text
                label="Wait time before sending (in minutes)"
                v-model="auto_response.wait_time_before_sending_in_minutes"
                integer_positive
                v-on:input="postInbox"
            />

            <v-select
                label="Send From"
                :items="send_from_options"
                :value="createSendFromValue(auto_response.send_from)"
                v-on:input="onChangeSendFrom($event, index)"
            />

            <m-edit-message-patterns-compact
                label="Auto Response Message"
                v-model="auto_response.message_patterns"
                context="inbox-auto-response"
                v-on:input="postInbox"
            />

            <m-edit-blobs
                label="Image to send with auto response (optional)"
                empty_text="No image"
                v-model="auto_response.blob_ids"
                :process_media="true"
                :externally_visible="true"
                :allow_multiple="false"
                :limit_to_size="460800"
                style="margin-bottom: 0px; margin-top: 15px"
                edit_icon="mdi-lead-pencil"
                dialog_title="Inbox Auto Response Image"
                dialog_hint="<b>Image limitations:</b>  Images <b>must</b> be 450 Kb or smaller.<br/><br/><b>Image size:  </b>For best results, images should be square or close to square.  The ideal image size is 400 x 400 pixels."
                v-on:input="postInbox"
            />

            <m-select-vcard
                label="Contact card to send with auto response (optional)"
                v-model="auto_response.vcard_id"
                v-on:input="postInbox"
            />

        </v-card-text>

        <div
            style="position: absolute; right: 20px; top: 20px;"
        >
            <v-menu
                bottom
                offset-y
            >

                <template v-slot:activator="{ on }">

                    <v-icon
                        v-on="on"
                        color="primary"
                    >
                        mdi-dots-vertical
                    </v-icon>

                </template>

                <v-list>
                    <v-list-item
                        v-on:click="deleteAutoResponse(index)"
                    >
                        <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="onClickCopyFromAnotherInbox(index)"
                    >
                        <v-list-item-title>Copy settings to/from another inbox...</v-list-item-title>
                    </v-list-item>
                </v-list>

            </v-menu>
        </div>
    </v-card>

    <v-row>
        <v-col>
        </v-col>

        <v-col
            class='flex-grow-0'
        >
            <v-btn
                class="mx-2" fab dark small color="primary"
                v-on:click="addAutoResponse()"
            >
                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
        </v-col>
    </v-row>

    <h2
        style="margin-bottom: 15px;"
    >
        Automatic Actions
    </h2>

    <v-checkbox
        label="Immediately mark as replied to (without a message)"
        v-model="inbox.immediately_mark_as_replied"
        v-on:change="postInbox"
    />

    <v-checkbox
        label="Immediately send auto responses (still respects active vs. inactive hours)"
        v-model="inbox.immediately_send_auto_responses"
        v-on:change="postInbox"
        style="margin-top: -15px"
    />

    <v-select
        label="Automatically add to list(s)"
        :items="list_choices"
        v-model="inbox.place_on_list_ids"
        v-on:change="postInbox"
        multiple
    />

    <v-divider
        style="margin-top: 15px; margin-bottom: 15px;"
    />

    </div>

    <h2>Test This Inbox</h2>

        <p>Clicking the button below will open a test page that will allow you to submit a contact request using this inbox</p>

        <div
            style="text-align: right"
            v-on:click="showTestPage"
        >
            <v-btn
                color="primary"
            >
                Open Test Widget Page In New Window
            </v-btn>
        </div>

    <v-divider
        style="margin-top: 15px; margin-bottom: 15px;"
    />

    <h2>Help</h2>

    <m-settings-organization-help-widget
        :inboxes="help_widget_inboxes"
    />

</v-container>

<m-copy-inbox-value-dialog
    ref="copy-dialog"
    :choices_inbox="choices_inbox"
    v-on:ok="copyNotificationPlan($event)"
/>

<m-dialog-admin-select-inbox-to-forward-to
    ref="forward-to-dialog"
    v-on:ok="onSetForwardTo($event)"
/>

</m-pageframe>
</template>

<script>

const { v4: uuidv4 } = require('uuid');

const _ = require('lodash');
const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            organization_id: null,
            inbox_id: null,

            inbox: null,
            read_only: false,

            selector_options: [],
            send_from_options: [],

            choices_inbox: [],

            domains: [],

            list_choices: [],

            during_intervals: [
                { 'text' : 'Active Hours', 'value' : 'active-hours' },
                { 'text' : 'Inactive Hours', 'value' : 'inactive-hours' }
            ],

            notification_options: [
                { 'text' : 'Simultaneously notify all users that are available', code: 'simultaneous' },
                { 'text' : 'Pick, at random, one RedChirp user who is available and notify them', code: 'random' },
                { 'text' : 'Using round robin, pick one RedChirp user who is available and notify them', code: 'round-robin' },
            ],
        }
    },

    mounted () {
        this.update();
        this.getLists();

        if (this.$route.query.newly_created == 'true') {
            this.$rc.snackbar('Inbox created successfully!');
            this.$router.replace({ query: null });
        }
    },

    methods: {

        update()
        {
            this.organization_id = this.$route.params.organization_id;
            this.inbox_id = this.$route.params.inbox_id;

            this.$rc.showSpinner();

            this.$rc.rest(
                'GET-PROFILE: /api/v1/inboxes/:inbox_id',

                {
                    'inbox_id' : this.inbox_id,
                },

                (data) => {
                    this.$rc.hideSpinner();


                    this.selector_options = data.employee_selector_options;
                    this.inbox = data.inbox;
                    this.read_only = !data.can_write;
                    this.send_from_options = data.choices_endpoints;
                    this.choices_inbox = data.choices_inbox;
                },

                () => {
                    this.$rc.hideSpinner();

                    alert('Unable to load inbox');
                    this.$router.push({
                        name: 'home',
                    });
                },
            );
        },

        getLists()
        {
            this.$rc.rest(
                'LIST: /api/v1/lists/choose-org-list',

                {
                    'organization_id': this.$route.params.organization_id,
                    'include_auto_lists' : false,
                },

                (data) => {
                    this.list_choices = data.results;
                },

                () => {
                    this.$rc.alert('Error','Unable to get lists');
                },
            );
        },

        postInbox()
        {
            this.$rc.showSpinner();

            this.$rc.rest(
                'PUT: /api/v1/inboxes',

                this.inbox,

                (data) => {
                    this.$rc.hideSpinner();
                    this.inbox = data;
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to save inbox');
                },
            );
        },

        validationRules(index)
        {
            let required = value => {
                if ( value == null ) return 'Required.';
                if ( (''+value).trim().length == 0 ) return 'Required.';
                return true;
            };

            let no_active_time = (value) => {
                let auto_response = this.inbox.auto_responses[index];
                if ( auto_response.during == 'active-hours' && value.toLowerCase().includes('%next_active_time%') )
                {
                    return 'Cannot use variable %NEXT_ACTIVE_TIME% during active hours.';
                }

                return true;
            };

            let ret = [];
            ret.push(required);
            ret.push(no_active_time);

            return ret;
        },

        createSendFromValue(send_from)
        {
            if ( send_from == null )
                return 'send-from-bot';

            return send_from;
        },

        onChangeSendFrom(value, index)
        {
            if ( value == 'send-from-bot' ) value = null;
            this.inbox.auto_responses[index].send_from = value;

            this.postInbox();
        },

        createStageChips(stage)
        {
            // selected_object_ids


            let selected_object_ids = stage.step.action.employee_selector.selected_object_ids;

            let ret = [];

            for ( let i = 0; i < selected_object_ids.length; i++ )
            {
                let label = this.getObjectDesc(selected_object_ids[i]);
                if ( label == null ) continue;

                ret.push({
                    'text' : label,
                    'selected_object_id' : selected_object_ids[i]
                })
            }

            return ret;
        },

        createPossibleChips()
        {
            let options = this.selector_options;

            let ret = [];

            for ( let i = 0; i < options.length; i++ )
            {
                if ( options[i].is_archived )
                    continue;

                ret.push({
                    'text' : options[i].label,
                    'selected_object_id' : options[i].selected_object_id,
                });
            }

            return ret;
        },

        getObjectDesc(id)
        {
            let options = this.selector_options;
            if ( options == null ) return null;

            for ( let i = 0; i < options.length; i++ )
            {
                if ( options[i].selected_object_id == id )
                    return options[i].label;
            }

            return null;
        },

        setStageValue(event, index)
        {
           let obj_ids = [];

           for ( let i = 0; i < event.length; i++ )
           {
               let cur_event = event[i];

               obj_ids.push(cur_event.selected_object_id);
           }

           this.inbox.plan.stages[index].step.action.employee_selector.selected_object_ids = obj_ids;

           this.postInbox();
        },

        getNotificationType(type)
        {
            let options = this.notification_options;

            for ( let i = 0; i < options.length; i++ )
            {
                if ( options[i].code == type )
                    return options[i];
            }

            return { 'text' : type, 'code' : type };
        },

        setNotificationType(value,stage_index)
        {
            this.inbox.plan.stages[stage_index].step.action.type = value.code;
            this.postInbox();
        },

        describeWaitTime(wait_time)
        {
            let in_minutes = wait_time / 1000 / 60;

            return Math.round(in_minutes);
        },

        setWaitTime(value, index)
        {
            let as_int = parseInt(value);

            if ( isNaN(as_int) || as_int < 1 )
            {
                alert("Value must be an number of minutes greater than or equal to one");
                return;
            }

            this.inbox.plan.stages[index].step.wait_time = as_int*1000*60;

            this.postInbox();
        },

        setRepeatCount(value,index)
        {
            let as_int = parseInt(value);

            this.inbox.plan.stages[index].repeat_count = as_int;

            this.postInbox();
        },

        addAutoResponse()
        {
            this.inbox.auto_responses.push(this.createDefaultAutoResponse());
            this.postInbox();
        },

        deleteAutoResponse(index)
        {
            this.inbox.auto_responses.splice(index, 1);
            this.postInbox();
        },

        newStage(index, is_before)
        {
            let new_index = index;

            if ( !is_before )
                new_index++;

            this.inbox.plan.stages.splice(new_index, 0, this.createDefaultStage());

            this.postInbox();
        },

        addStage()
        {
            this.inbox.plan.stages.push(this.createDefaultStage());
            this.postInbox();
        },

        moveStage(index, move_up)
        {
            let other_index = index-1;

            if( !move_up )
                other_index = index+1;

            if ( other_index < 0 ) return;
            if ( other_index >= this.inbox.plan.stages.length ) return;

            let at_index = this.inbox.plan.stages[index];
            let at_other_index = this.inbox.plan.stages[other_index];

            this.inbox.plan.stages[index] = at_other_index;
            this.inbox.plan.stages[other_index] = at_index;

            this.postInbox();
        },

        deleteStage(index)
        {
            this.inbox.plan.stages.splice(index, 1);
            this.postInbox();
        },

        createDefaultAutoResponse()
        {
            return {
                "enabled" : true,
                "during" : "active-hours",
                "wait_time_before_sending_in_minutes" : 10,
                "message" : "Hi %FIRST_NAME%, it's taking longer than we hoped to connect you with someone here at %ORGANIZATION_NAME% but we're working on it! Someone will text you soon."
            };
        },

        createDefaultStage()
        {
            return {
            "step":
            {
                "action": {
                "type": "simultaneous",
                "employee_selector": {
                    "organization_id": this.inbox.organization_id,
                    "selected_object_ids": []
                },
                "action_id": ''+uuidv4()
                },
                "wait_time": 300000
            },
            "repeat_count": 2
            };
        },

        onClickCopyFromAnotherInbox()
        {
            this.$refs['copy-dialog'].showDialog(this.inbox_id);
        },

        copyNotificationPlan(params)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/inboxes/copy-inbox-settings',

                'params' : params,

                'on_success': (data) => {
                        this.$rc.snackbar('Settings have been copied', 3000);
                        this.update();
                    },

                'on_error': 'Unable to copy settings',
            });
        },

        showTestPage()
        {
            let query_string = '?inbox_ids='+encodeURIComponent(this.inbox.organization_id+':'+this.inbox.inbox_id)+'&ref='+encodeURIComponent(window.location.href);
            let url = this.$rc.getAPIEndpoint('widget/test-website-page.html')+query_string;

            window.open(url, "_blank");
        },

        onClickInboxEmailLog()
        {
             this.$router.push({
                'name': 'inbox-email-log',
                'params' : {
                    'organization_id' : this.inbox.organization_id,
                    'inbox_id' : this.inbox_id,
                }
            }).catch(e=>{}); // swallow any exception
        },

        onClickEditForwardTo()
        {
            this.$refs['forward-to-dialog'].showDialog();
        },

        onSetForwardTo(inbox_id)
        {
            this.inbox.forward_to_inbox_id = inbox_id;
            this.postInbox();
        },

    },

    computed: {

        page_title() {
            return this.inbox == null ? 'Edit Inbox' : 'Edit Inbox: '+this.inbox.internal_label;
        },

        help_widget_inboxes() {
            return [{
                    'text' : this.inbox.help_with,
                    'organization_id' : this.inbox.organization_id,
                    'inbox_id' : this.inbox.inbox_id,
                }];
        },

        forward_to() {
            if ( this.inbox == null ) return 'Not forwarded';
            if ( this.inbox.forward_to_inbox_label == null ) return 'Not forwarded';

            let label = this.inbox.forward_to_inbox_label;

            return label.organization_label+' > '+label.internal_label;
        },

        has_forward_to() {
            if ( this.inbox == null ) return false;
            if ( this.inbox.forward_to_inbox_label == null ) return false;

            return true;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>